import styled from 'styled-components';
import { Flex } from 'antd';
import { maxWidth } from 'config/constants';

export const StyledEmailVerificationPage = styled(Flex)`
  width: 100%;
  height: 100%;
  background: white;
`;

export const StyledEmailVerificationContent = styled(Flex)`
  .ant-form-item-explain-success {
    padding-top: ${({ theme }): number => theme.kcc.padding.CONTENT_VERTICAL_SM / 4}px;
    padding-left: ${({ theme }): number => theme.kcc.padding.CONTENT_VERTICAL_SM}px;
  }

  width: 100%;
  max-width: 580px;
  margin: auto;

  ${maxWidth.l} {
    max-width: 100%;
    padding: 40px 36px;
    margin: 0 auto;
  }

  ${maxWidth.m} {
    padding: 48px 23px;
    margin: 0;

    .email-verification__resend-code-countdown {
      align-items: center;
    }
  }

  .ant-form-item-explain-error {
    i {
      margin-top: 2px;
      width: 14px;
      height: 14px;

      svg {
        width: 14px;
        height: 14px;

        path {
          fill: ${(props): string => props.theme.kcc.colors.RED[300]};
        }
      }
    }
  }
`;

export const StyledOTPWrapper = styled.div<{ $state: 'error' | 'success' | undefined }>`
  width: 100%;

  .ant-otp {
    width: 100%;
    gap: 16px;
  }

  .ant-otp-input:disabled {
    border-color: ${(props): string => props.theme.kcc.colors.BORDER_DISABLED} !important;
    background: transparent;

    :hover {
      border-color: ${(props): string => props.theme.kcc.colors.BORDER_DISABLED} !important;
    }
  }

  .ant-otp-input,
  .ant-input {
    width: 48px;
    height: 60px;
    font-size: 18px;
    font-weight: 700;
    line-height: 27px;
    border-radius: ${(props): number => props.theme.kcc.borderRadius.INPUT / 2}px;
    border: 2px solid ${(props): string => props.theme.kcc.colors.BORDER_SECONDARY} !important;
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    transition: border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  .ant-otp-input:hover,
  .ant-input:hover {
    border-color: ${(props): string => props.theme.kcc.colors.PRIMARY} !important;
  }

  .ant-otp-input:focus,
  .ant-otp-input:focus-visible,
  .ant-input:focus,
  .ant-input:focus-visible {
    border-color: ${(props): string => props.theme.kcc.colors.PRIMARY} !important;
    outline: none;
  }

  .ant-otp-input:not([value='']),
  .ant-input:not([value='']) {
    ${({ $state, theme }): string => (!$state ? `border-color: ${theme.kcc.colors.TEXT} !important;` : '')}
  }

  .ant-otp-input,
  .ant-input,
  .kcc-theme-input:not([value='']):not(.ant-input-status-error) {
    ${({ $state, theme }): string =>
      $state === 'error' ? `border-color: ${theme.kcc.colors.RED[300]} !important;` : ''}
    ${({ $state, theme }): string =>
      $state === 'success' ? `border-color: ${theme.kcc.colors.SUCCESS} !important;` : ''}
  }

  .ant-otp-input:focus,
  .ant-otp-input:focus-visible,
  .ant-input:focus,
  .ant-input:focus-visible {
    ${({ $state, theme }): string =>
      $state === 'error'
        ? `
    border-color: ${theme.kcc.colors.RED[300]} !important;
    box-shadow: 0 0 0 2px ${theme.kcc.colors.RED[50]} !important;
  `
        : ''}
    ${({ $state, theme }): string =>
      $state === 'success'
        ? `
    border-color: ${theme.kcc.colors.SUCCESS} !important;
    box-shadow: 0 0 0 2px ${theme.kcc.colors.GREEN[50]} !important;
  `
        : ''}
  }
`;
